import { render, staticRenderFns } from "./WidgetPowerwallInstallers.vue?vue&type=template&id=168fc438&scoped=true&"
import script from "./WidgetPowerwallInstallers.vue?vue&type=script&lang=js&"
export * from "./WidgetPowerwallInstallers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fc438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168fc438')) {
      api.createRecord('168fc438', component.options)
    } else {
      api.reload('168fc438', component.options)
    }
    module.hot.accept("./WidgetPowerwallInstallers.vue?vue&type=template&id=168fc438&scoped=true&", function () {
      api.rerender('168fc438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/WidgetPowerwallInstallers.vue"
export default component.exports